import { render, staticRenderFns } from "./UserButton.vue?vue&type=template&id=ba819870&scoped=true&"
import script from "./UserButton.vue?vue&type=script&lang=js&"
export * from "./UserButton.vue?vue&type=script&lang=js&"
import style0 from "./UserButton.vue?vue&type=style&index=0&id=ba819870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba819870",
  null
  
)

export default component.exports